import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, withKeys as _withKeys, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-32e93d10"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "check-paymant-page" }
const _hoisted_2 = { class: "check-paymant-block" }
const _hoisted_3 = { class: "cash-paymant-block-name" }
const _hoisted_4 = { class: "first-subsection" }
const _hoisted_5 = { class: "label" }
const _hoisted_6 = { class: "label" }
const _hoisted_7 = { class: "label" }
const _hoisted_8 = { class: "label" }
const _hoisted_9 = { class: "second-subsection" }
const _hoisted_10 = { class: "label" }
const _hoisted_11 = { class: "label justify-self-center" }
const _hoisted_12 = { class: "label" }
const _hoisted_13 = { class: "label justify-self-center" }
const _hoisted_14 = { class: "first-subsection" }
const _hoisted_15 = { class: "label" }
const _hoisted_16 = { class: "d-flex justify-content-center" }
const _hoisted_17 = {
  class: "p-ripple submit-btn",
  "data-index": "10",
  type: "submit",
  form: "paymentForm"
}
const _hoisted_18 = { class: "buttons-block" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ViewHeader = _resolveComponent("ViewHeader")!
  const _component_DropdownInput = _resolveComponent("DropdownInput")!
  const _component_NumberInput = _resolveComponent("NumberInput")!
  const _component_TextInput = _resolveComponent("TextInput")!
  const _component_DateInput = _resolveComponent("DateInput")!
  const _component_TotalRow = _resolveComponent("TotalRow")!
  const _component_BackAndCancelFooter = _resolveComponent("BackAndCancelFooter")!
  const _directive_ripple = _resolveDirective("ripple")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ViewHeader, {
      text: _ctx.$t('newOrder.add-check-payment')
    }, null, 8, ["text"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("form", {
        action: "",
        id: "paymentForm",
        onSubmit: _cache[17] || (_cache[17] = _withModifiers(($event: any) => (_ctx.submitForm($event)), ["prevent"])),
        novalidate: ""
      }, [
        _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('cashier.label.check')), 1),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('cashier.label.bank')), 1),
          _createVNode(_component_DropdownInput, {
            modelValue: _ctx.payment.bankId,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.payment.bankId) = $event)),
            options: _ctx.banks,
            optionLabel: "name",
            optionValue: "id",
            placeholder: _ctx.$t('cashier.placeholder.select-bank'),
            scope: _ctx.validation.scope,
            rules: _ctx.validation.rules.bankId,
            inputProps: { 'data-index': 1 },
            onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.focusNext([1])))
          }, null, 8, ["modelValue", "options", "placeholder", "scope", "rules"]),
          _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t('cashier.label.branch')), 1),
          _createVNode(_component_NumberInput, {
            modelValue: _ctx.payment.bankBranchNumber,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.payment.bankBranchNumber) = $event)),
            scope: _ctx.validation.scope,
            rules: _ctx.validation.rules.bankBranchNumber,
            useGrouping: false,
            max: 99999,
            inputProps: { 'data-index': 2 },
            onKeydown: _cache[3] || (_cache[3] = _withKeys(_withModifiers(($event: any) => (_ctx.focusNext([2])), ["prevent"]), ["enter"]))
          }, null, 8, ["modelValue", "scope", "rules"]),
          _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t('cashier.label.account')), 1),
          _createVNode(_component_TextInput, {
            modelValue: _ctx.payment.accountNumber,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.payment.accountNumber) = $event)),
            scope: _ctx.validation.scope,
            rules: _ctx.validation.rules.accountNumber,
            inputProps: { 'data-index': 3 },
            onKeydown: _cache[5] || (_cache[5] = _withKeys(_withModifiers(($event: any) => (_ctx.focusNext([3])), ["prevent"]), ["enter"]))
          }, null, 8, ["modelValue", "scope", "rules"]),
          _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t('cashier.label.check-number')), 1),
          _createVNode(_component_TextInput, {
            numeric: true,
            modelValue: _ctx.payment.checkNumber,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.payment.checkNumber) = $event)),
            maxLength: 20,
            scope: _ctx.validation.scope,
            rules: _ctx.validation.rules.checkNumber,
            useGrouping: false,
            max: 2147483647,
            inputProps: { 'data-index': 4 },
            onKeydown: _cache[7] || (_cache[7] = _withKeys(_withModifiers(($event: any) => (_ctx.focusNext([4])), ["prevent"]), ["enter"]))
          }, null, 8, ["modelValue", "scope", "rules"])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t('cashier.label.date')), 1),
          _createVNode(_component_DateInput, {
            modelValue: _ctx.payment.valueDate,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.payment.valueDate) = $event)),
            scope: _ctx.validation.scope,
            rules: _ctx.validation.rules.amount,
            inputProps: { 'data-index': 5 },
            onChange: _cache[9] || (_cache[9] = ($event: any) => (_ctx.focusNext([5])))
          }, null, 8, ["modelValue", "scope", "rules"]),
          _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t('cashier.label.amount')), 1),
          _createVNode(_component_NumberInput, {
            modelValue: _ctx.payment.amount,
            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.payment.amount) = $event)),
            scope: _ctx.validation.scope,
            rules: _ctx.validation.rules.amount,
            mode: 'decimal',
            minFractionDigits: 2,
            maxFractionDigits: 2,
            inputProps: { 'data-index': 6 },
            onKeydown: _cache[11] || (_cache[11] = _withKeys(_withModifiers(($event: any) => (_ctx.focusNext([6])), ["prevent"]), ["enter"]))
          }, null, 8, ["modelValue", "scope", "rules"]),
          _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$t('cashier.label.currency')), 1),
          _createVNode(_component_DropdownInput, {
            onChange: _ctx.changeCurrency,
            modelValue: _ctx.payment.currencyId,
            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.payment.currencyId) = $event)),
            options: _ctx.currencies,
            optionLabel: "name",
            optionValue: "id",
            placeholder: _ctx.$t('cashier.placeholder.select-currency'),
            scope: _ctx.validation.scope,
            rules: _ctx.validation.rules.currencyId,
            inputProps: { 'data-index': 7 }
          }, null, 8, ["onChange", "modelValue", "options", "placeholder", "scope", "rules"]),
          (_ctx.localCurrencyId != _ctx.payment.currencyId)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.$t('cashier.label.rate')), 1),
                _createVNode(_component_NumberInput, {
                  modelValue: _ctx.payment.localCurrencyRate,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.payment.localCurrencyRate) = $event)),
                  scope: _ctx.validation.scope,
                  rules: _ctx.validation.rules.localCurrencyRate,
                  readonly: !_ctx.canEditRate,
                  minFractionDigits: 1,
                  maxFractionDigits: 3,
                  inputProps: { 'data-index': 8 },
                  onKeydown: _cache[14] || (_cache[14] = _withKeys(_withModifiers(($event: any) => (_ctx.focusNext([8])), ["prevent"]), ["enter"]))
                }, null, 8, ["modelValue", "scope", "rules", "readonly"])
              ], 64))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.$t('label.check-owner')), 1),
          _createVNode(_component_TextInput, {
            modelValue: _ctx.payment.owner,
            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.payment.owner) = $event)),
            scope: _ctx.validation.scope,
            rules: _ctx.validation.rules.owner,
            inputProps: { 'data-index': 9 },
            onKeydown: _cache[16] || (_cache[16] = _withKeys(_withModifiers(($event: any) => (_ctx.focusNext([9])), ["prevent"]), ["enter"]))
          }, null, 8, ["modelValue", "scope", "rules"])
        ])
      ], 32),
      _createVNode(_component_TotalRow, {
        total: _ctx.total,
        paymentCurrencyId: _ctx.payment.currencyId
      }, null, 8, ["total", "paymentCurrencyId"]),
      _createElementVNode("div", _hoisted_16, [
        _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_17, [
          _createTextVNode(_toDisplayString(_ctx.$t('cashier.add-payment')), 1)
        ])), [
          [_directive_ripple]
        ])
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("button", {
          type: "button",
          onClick: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.addAnother && _ctx.addAnother(...args)))
        }, _toDisplayString(_ctx.$t('cashier.label.add-another-check')), 1),
        _createElementVNode("button", {
          type: "button",
          onClick: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.clear && _ctx.clear(...args)))
        }, _toDisplayString(_ctx.$t('cashier.label.clear')), 1)
      ])
    ]),
    _createVNode(_component_BackAndCancelFooter)
  ]))
}